<template>
  <div class="hs-popup-mask-box" @click="currentValue = false">
    <transition name="hs-popup-mask">
      <div class="hs-popup-mask" v-show="currentValue"></div>
    </transition>
    <transition name="address-picker">
      <div
        class="hs-address-picker"
        :class="{'hs-address-picker-new': switchList[activeIndex] === INTEL_HOTEL_BLANK}"
        @click.stop
        v-if="currentValue && cityData && cityData.list"
      >
        <c-header :title="title">
          <!--<p slot="left" @click="currentValue = false">{{$t('Cancel')}}</p>-->
          <hs-close slot="right" @click.native="currentValue = false" />
        </c-header>
        <!-- 搜索框 -->
        <hs-address-picker-search-bar
          v-if="multiple"
          :searchTxt="searchTxt"
          :placeholder="SearchBarPlaceholder"
          :cityLists="multipleCities"
          @delete="_multipleDelete"
          @inputClick="showSearchDetails = true"
          @confirm="_confirm"
        />

        <div class="search-bar search-bar-new" v-else>
          <div class="bar" @click="showSearchDetails = true">
            <div
              class="logo"
              :style="{backgroundImage: `url(${require('@/assets/image/plane-ticket/book/search.png')})`}"
            ></div>
            <input
              class="disabled"
              maxlength="50"
              v-model.trim="searchTxt"
              :placeholder="SearchBarPlaceholder"
            />
          </div>
        </div>
        <!-- 搜索框详情 -->

        <div v-if="showSearchDetails" class="search-details">
          <div class="search-bar" style="height: 55px">
            <div class="bar">
              <div
                class="logo"
                :style="{backgroundImage: `url(${require('@/assets/image/plane-ticket/book/search.png')})`}"
              ></div>
              <input
                autofocus
                maxlength="50"
                v-model.trim="searchTxt"
                :placeholder="SearchBarPlaceholder"
              />
            </div>
            <p @click="_cancel" class="close">
              {{ $t("Cancel") }}
            </p>
          </div>
          <hs-scroll class="vaguelist" :data="vaguelist">
            <ul>
              <hs-null
                  v-if="!noValue(searchTxt) && vaguelist.length === 0"
                  style="padding-top: calc(38dvh - 78px)"
                  styleType="noResultsFound"
                  :title="$t('NoDataBySearch')"
              />
              <hs-section v-else>
                <!--汽车票 start-->
                <template v-if="OrderBusinessType === 18">
                  <hs-cell-1
                    :showLogo="false"
                    :showSeparator="
                      !(item.StationInfoList && item.StationInfoList.length > 0)
                    "
                    v-for="(item, index) in vaguelist"
                    :key="index"
                  >
                    <ul class="search-list">
                      <li
                        class="item-city"
                        :type="language"
                        @click="_select(item)"
                      >
                        <p>{{ $t("City") }}</p>
                        <p>{{ getCityName(item) }}</p>
                        <p>
                          {{ item.CityCode }}
                        </p>
                      </li>
                      <li
                        class="item-airport"
                        v-if="
                          item.StationInfoList &&
                          item.StationInfoList.length > 0
                        "
                        v-for="(itemChild, indexChild) in item.StationInfoList"
                        :key="indexChild"
                        @click="_select(itemChild)"
                        :style="{
                          'border-bottom-width':
                            index + 1 === vaguelist.length &&
                            indexChild + 1 === item.StationInfoList.length
                              ? '0px'
                              : '1px',
                        }"
                      >
                        <div class="item-airport-details" :type="language">
                          <div class="logo icon-plane-enter"></div>
                          <div class="details">
                            <p>{{ "车站" }}</p>
                            <p>{{ itemChild.StationName }}</p>
                            <p>{{ itemChild.StationCode }}</p>
                          </div>
                        </div>
                        <!-- <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/address-picker/plane.png')})`}"></div> -->
                      </li>
                    </ul>
                  </hs-cell-1>
                </template>
                <!--汽车票 end-->

                <!--出差申请单-->
                <template v-else-if="OrderBusinessType === 17">
                  <hs-cell-1
                    :showLogo="false"
                    :showSeparator="
                      !(item.Children && item.Children.length > 0)
                    "
                    v-for="(item, index) in vaguelist"
                    :key="index"
                  >
                    <ul class="search-list">
                      <li
                        class="item-city item-city-new"
                        @click="_select(item)"
                      >
                        <p v-show="false">{{ $t("City") }}</p>
                        <div class="item-city-name">
                          <div class="icon"></div>
                          <span
                            >{{ getCityName(item) }}
                            <template v-if="item.CityType === 2"
                              >({{ getCountryName(item) }})</template
                            ></span
                          >
                        </div>
                        <p class="subtext" v-if="getCityLongName(item)">
                          {{ getCityLongName(item) }}
                        </p>
                      </li>
                    </ul>
                  </hs-cell-1>
                </template>

                <template
                  v-else-if="
                    blank === PLANE_BLANK || blank === INTEL_PLANE_BLANK || blank === INTER_TRAVEL_BLANK
                  "
                >
                  <hs-cell-1
                    :showLogo="false"
                    :showSeparator="
                      !(item.Children && item.Children.length > 0)
                    "
                    v-for="(item, index) in vaguelist"
                    :key="index"
                  >
                    <ul class="search-list">
                      <li
                        class="item-city"
                        :type="language"
                        @click="item.IsAllowSelect && _select(item)"
                      >
                        <p>
                          <span class="is-near" v-if="item.IsNear">{{$t('Near')}}</span>
                          <span class="is-near" v-if="item.IsNear">{{getCityName(item)}}</span>
                          <span class="airport-type" v-else>{{`${item.GeoType === 1 ? $t("Airport") : $t("City")}`}}</span>
                        </p>
                        <p>
                          {{ getAirPortName(item)
                          }}<template v-if="item.CountryType === '国际'"
                            >({{ getCountryName(item) }})</template
                          >
                        </p>
                        <p>
                          {{ item.AirPortCode }}
                        </p>
                      </li>
                      <li
                        class="item-airport"
                        v-if="item.Children && item.Children.length > 0"
                        v-for="(itemChild, indexChild) in item.Children"
                        :key="indexChild"
                        @click="itemChild.IsAllowSelect && _select(itemChild)"
                        :style="{
                          'border-bottom-width':
                            index + 1 === vaguelist.length &&
                            indexChild + 1 === item.Children.length
                              ? '0px'
                              : '1px',
                        }"
                      >
                        <div class="item-airport-details" :type="language">
                          <div class="logo icon-plane-enter"></div>
                          <div class="details">
                            <p>
                              <span class="is-near" v-if="itemChild.IsNear">{{$t('Near')}}</span>
                              <span class="is-near" v-if="itemChild.IsNear">{{getCityName(itemChild)}}</span>
                              <span class="airport-type" v-else>{{`${itemChild.GeoType === 1 ? $t("Airport") : $t("City")}`}}</span>
                            </p>
                            <p>{{ getAirPortName(itemChild) }}</p>
                            <p>{{ itemChild.AirPortCode }}</p>
                          </div>
                        </div>
                        <!-- <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/address-picker/plane.png')})`}"></div> -->
                      </li>
                    </ul>
                  </hs-cell-1>
                </template>

                <template v-else-if="blank === CAR_BLANK">
                  <hs-cell-1
                    :showLogo="false"
                    v-for="(item, index) in vaguelist"
                    :key="index"
                  >
                    <ul class="search-list">
                      <li class="item-city" @click="_select(item)">
                        <p v-show="false">{{ $t("City") }}</p>
                        <p>{{ getCityName(item) }}</p>
                      </li>
                    </ul>
                  </hs-cell-1>
                </template>

                <template v-else-if="blank === HOTEL_BLANK">
                  <!--<hs-cell-1 :showLogo="false" v-for="(item, index) in vaguelist" :key="index">
                    <ul class="search-list">
                      <li class="item-city item-city-new" @click="_select(item)">
                        <p v-show="false">{{$t('City')}}</p>
                        <div class="item-city-name">
                          <div class="icon"></div>
                          <span>{{item.Name}}</span>
                        </div>
                        <p class="subtext">{{item.SubTitle}}</p>
                      </li>
                    </ul>
                  </hs-cell-1>-->
                  <c-hotel-filter-search-list
                    :KeyWord="searchTxt"
                    :datalist="vaguelist"
                    @select="_selectHotelSearch"
                  />
                </template>

                <template v-else-if="blank === INTEL_HOTEL_BLANK">
                  <c-hotel-filter-search-list
                    :KeyWord="searchTxt"
                    :datalist="vaguelist"
                    @select="_selectHotelSearch"
                  />
                </template>

                <template v-else-if="blank === TRAIN_BLANK">
                  <hs-cell-1
                    :showLogo="false"
                    v-for="(item, index) in vaguelist"
                    :key="index"
                  >
                    <hs-address-picker-search-item
                      :item="item"
                      :len="vaguelist.length"
                      :index="index"
                      @select="_select"
                    />
                  </hs-cell-1>
                </template>
              </hs-section>
            </ul>
          </hs-scroll>
        </div>

        <hs-tab
          v-if="showSwitchBar"
          source="scale"
          className="hs-tab-scale-color"
          :selectedIndex="activeIndex"
          :options="switchList"
          @select="_selectSwitchItem"
        ></hs-tab>
        <!--回到顶部-->
        <div
            v-if="showBackToTop"
            class="back-to-top"
            :style="{backgroundImage: `url(${require('@/assets/image/base/back-top.png')})`}"
            @click="_backTop"
        ></div>
        <van-list
            ref="tableView"
            :data="cityData.list"
            class="tableView"
            v-if="
                switchList[activeIndex] === $t('China') ||
                switchList[activeIndex] === $t('ChinaRegion') ||
                switchList[activeIndex] === $t('International') ||
                switchList[activeIndex] === $t('City') ||
                switchList[activeIndex] === $t('Car')
              "
            :style="{
                height: showSwitchBar
                  ? 'calc(100% - 45px - 45px - 40px)'
                  : 'calc(100% - 45px - 45px)',
              }"
            @scroll.native="_scrollInit"
        >
          <ul>
            <hs-section class="fixedTouch" :headerShortHeight="switchList[activeIndex] === INTEL_HOTEL_BLANK ? '0' : '10px'">
              <!--出差申请单城市列表 start-->
              <hs-address-picker-item
                  v-if="domesticApplicationFormCities && domesticApplicationFormCities.length > 0"
                  :header="getSetting('国内机票配置:正常订单:授权码名称')"
                  :item="{CityList: domesticApplicationFormCities}"
                  :showMoreBtn="false"
                  :OrderBusinessType="OrderBusinessType"
                  @select="_select"
                  :defaultMultipleCities="switchList[activeIndex] === INTEL_HOTEL_BLANK ? defaultMultipleCities : []"
                  :showCityCode="switchList[activeIndex] !== HOTEL_BLANK && switchList[activeIndex] !== INTEL_HOTEL_BLANK"
              />

              <!--历史-->
              <hs-address-picker-item
                  v-else-if="historyAddress && historyAddress.length > 0"
                  :header="blank === INTEL_HOTEL_BLANK ? $t('RecentSearches') : $t('HistoryOrLocation')"
                  :OrderBusinessType="OrderBusinessType"
                  :item="{CityList: locationCity && locationCity.CityCode ? [...historyAddress, locationCity] : historyAddress}"
                  :showMoreBtn="false"
                  :clearable="switchList[activeIndex] === INTEL_HOTEL_BLANK"
                  :defaultMultipleCities="switchList[activeIndex] === INTEL_HOTEL_BLANK ? defaultMultipleCities : []"
                  :showCityCode="switchList[activeIndex] !== HOTEL_BLANK && switchList[activeIndex] !== INTEL_HOTEL_BLANK"
                  @select="_select"
                  @clear="_clearHistory"
              />
              <!--热门城市 end-->
              <hs-address-picker-item
                  v-if="cityData.hot"
                  :OrderBusinessType="OrderBusinessType"
                  :header="$t('Hot')"
                  :showMoreBtn="false"
                  :item="cityData.hot"
                  :defaultMultipleCities="switchList[activeIndex] === INTEL_HOTEL_BLANK ? defaultMultipleCities : []"
                  :showCityCode="switchList[activeIndex] !== HOTEL_BLANK && switchList[activeIndex] !== INTEL_HOTEL_BLANK"
                  @select="_select"
              />

              <!--索引-->
              <hs-address-picker-item
                  v-if="cityData.list"
                  childType="small"
                  :OrderBusinessType="OrderBusinessType"
                  :header="$t('Indexs')"
                  :showMoreBtn="false"
                  :item="{CityList: cityData.list}"
                  @select="_selectLetter"
              />
              <hs-address-picker-item
                  :ref="`letter${item.Label}${index}`"
                  @select="_select"
                  :OrderBusinessType="OrderBusinessType"
                  :showCountry="OrderBusinessType === 11"
                  :defaultMultipleCities="switchList[activeIndex] === INTEL_HOTEL_BLANK ? defaultMultipleCities : []"
                  :key="`letter${item.Label}${index}`"
                  v-for="(item, index) in cityData.list"
                  :showCityCode="switchList[activeIndex] !== HOTEL_BLANK && switchList[activeIndex] !== INTEL_HOTEL_BLANK"
                  :index="index"
                  :item="item"
              />
              <div style="height: 20px"></div>
            </hs-section>
          </ul>
        </van-list>

        <div
          v-else-if="
            (switchList[activeIndex] === $t('InternationalRegion') || blank === INTER_TRAVEL_BLANK) &&
            cityData.list &&
            cityData.list.length > 0
          "
          class="intl"
          :style="{
            height: showSwitchBar
              ? 'calc(100% - 45px - 40px - 40px)'
              : 'calc(100% - 45px - 40px)',
          }"
        >
          <hs-scroll class="left">
            <hs-section>
              <div
                @click="intlSelectedIndex = index"
                v-for="(item, index) in cityData.list"
                :key="index"
                class="item"
                :class="{ active: intlSelectedIndex === index }"
              >
                <p>{{ _getLabel(item) }}</p>
              </div>
            </hs-section>
          </hs-scroll>
          <hs-scroll class="right" :data="cityData.list">
            <hs-section v-if="cityData.list[intlSelectedIndex]">
              <!--出差申请单城市 start-->
              <template v-if="intlSelectedIndex === 0">
                <div
                  class="blank"
                  v-if="
                    interApplicationFormCities &&
                    interApplicationFormCities.length > 0
                  "
                  :type="language"
                >
                  <div class="header">{{ getSetting('国内机票配置:正常订单:授权码名称') }}</div>
                  <div class="details">
                    <div
                      @click="_select(item)"
                      v-for="(item, index) in interApplicationFormCities"
                      :key="index"
                      class="item"
                    >
                      <p>
                        {{
                          getAirPortName(item)
                            ? getAirPortName(item)
                            : getCityName(item)
                        }}
                        <span
                          class="gray"
                          v-if="language !== 'CN' && language !== 'TC'"
                        >
                          {{ item.CityCode }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="blank"
                  v-else-if="historyAddress && historyAddress.length > 0"
                  :type="language"
                >
                  <div class="header">{{ $t("RecentSearches") }}</div>
                  <div class="details">
                    <div
                      @click="_select(item)"
                      v-for="(item, index) in historyAddress"
                      :key="index"
                      class="item"
                    >
                      <p>
                        {{
                          getAirPortName(item)
                            ? getAirPortName(item)
                            : getCityName(item)
                        }}
                        <span
                          class="gray"
                          v-if="language !== 'CN' && language !== 'TC'"
                        >
                          {{ item.CityCode }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <!--出差申请单城市 end-->
              <div
                class="blank"
                v-for="(item, index) in cityData.list[intlSelectedIndex].Blanks"
                :key="index"
                :type="language"
              >
                <div class="header">{{ _getLabelCnOrEn(item) }}</div>
                <div class="details">
                  <div
                    @click="_select(itemChild)"
                    v-for="(itemChild, indexChild) in item.CityList"
                    :key="indexChild"
                    :class="[
                      Number(cityData.list[intlSelectedIndex].LabelType) !== 3
                        ? 'item'
                        : 'itemWidthImage',
                    ]"
                    :style="{backgroundImage: `url(${itemChild.ImageUrl})`}"
                  >
                    <p>
                      {{
                        getAirPortName(itemChild)
                          ? getAirPortName(itemChild)
                          : getCityName(itemChild)
                      }}
                      <span
                        class="gray"
                        v-if="
                          Number(cityData.list[intlSelectedIndex].LabelType) !==
                            3 &&
                          language !== 'CN' &&
                          language !== 'TC'
                        "
                      >
                        {{ itemChild.CityCode }}</span
                      >
                    </p>
                    <div
                      v-if="
                        Number(cityData.list[intlSelectedIndex].LabelType) === 3
                      "
                      class="mask"
                    ></div>
                  </div>
                </div>
              </div>
            </hs-section>
          </hs-scroll>
        </div>
      </div>
    </transition>
  </div>
</template>
<script type="text/ecmascript-6">
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import HsTab from 'base/hs-tab/hs-tab'
import HsAddressPickerSearchItem from './hs-address-picker-search-item'
import HsAddressPickerSearchBar from './hs-address-picker-search-bar'
import CHotelFilterSearchList from 'components/c-filter/c-hotel-filter/search-list'
import {
  kpiFlightSearchAirportCity,
  kpiIntlHotelGetIntlHotelCityByKeyword,
  kpiTrainSearchTrainStations,
  kpiFlightGetAllCities,
  kpiIntlflightGetIntlFlightCityList,
  kpiHotelGetHotelCityList,
  kpiIntlHotelGetIntlHotelCityList,
  kpiTrainGetTrainCityList
} from 'api'
import {
  kpiCarCityAvailableList,
  kpiCarCityQuery
} from 'api/car/carApi'
import {
  kpiApplicationCityList,
  kpiApplicationIntlCityList,
  kpiApplicationSearchCity
} from 'api/travelApply/travelApplyApi'
import {
  kpiBusCommonQueryCities,
  kpiBusCommonGetCitiesByKeyWord
} from 'api/bus/busApi'
import {kpiHotelGetHotelSearchEngine} from 'api/hotel/hotelApi'
import {cloneObject} from '@/common/utility/utils.js';
import HsNull from "@/base/hs-null/hs-null.vue";
import {LocationService} from "@/common/js/getCurrentLocation";
import {mapState} from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    switchList: {
      type: Array,
      default: function() {
        return []
      }
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    showSwitchBar: {
      type: Boolean,
      default: false
    },
    OrderBusinessType: { // 业务类型 17 出差申请单
      type: Number,
      default: 0
    },
    authCodeCityList: { // 出差申请单城市列表
      type: Array,
      default: function() {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultMultipleCities: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      /** 目的地信息 */
      cityData: {},
      locationCity: null, // 定位的城市信息
      /** 搜索关键字 */
      searchTxt: '',
      /** 展示搜索详情 */
      showSearchDetails: false,
      /** 所在板块 */
      blank: '',
      /** 搜索结果 */
      vaguelist: [],
      /** 国际机票地址左侧选中 */
      intlSelectedIndex: 0,
      /** 历史(Key) */
      localStorageHistoryKey: '',
      historyAddress: [],
      /**************************************/
      showBackToTop: false,


      multipleCities: [], // 多选-- 选中的城市

      INTER_TRAVEL_BLANK: this.$t('Intl_1'), // 出差申请单 国际
      PLANE_BLANK: this.$t('China'), // 机票国内
      INTEL_PLANE_BLANK: this.$t('InternationalRegion'), // 机票国际
      HOTEL_BLANK: this.$t('ChinaRegion'), // 酒店BLANK左右空一格和机票的做区分 国内
      INTEL_HOTEL_BLANK: this.$t('International'), // 酒店BLANK左右空一格和机票的做区分 国际
      TRAIN_BLANK: this.$t('City'), // 火车票
      CAR_BLANK: this.$t('Car') // 用车
    }
  },
  computed: {
    ...mapState([
      'AMapKey',
    ]),
    currentValue: {
      get: function(val) {
        return this.value
      },
      set: function(val) {
        return this.$emit('input', val)
      }
    },
    CityVersion() {
      return window.localStorage.CityVersion ? JSON.parse(window.localStorage.CityVersion) : {}
    },
    SearchBarPlaceholder() {
      let SearchBarPlaceholder = this.$t('PleaseEnterTheCity')
      if (this.blank === this.HOTEL_BLANK) {
        SearchBarPlaceholder = this.$t('PleaseEnterTheHotelCity')
      } else if (this.blank === this.INTEL_HOTEL_BLANK) {
        SearchBarPlaceholder = this.$t('PleaseEnterTheHotelCity')
      }
      return SearchBarPlaceholder
    },
    domesticApplicationFormCities() {
      return this.authCodeCityList.filter(m => m.CountryType !== '国际')
    }, // 国内出差申请单城市
    interApplicationFormCities() {
      return this.authCodeCityList.filter(m => m.CountryType === '国际')
    } // 国内出差申请单城市
  },
  watch: {
    currentValue(val) {
      if (val) {
        this._selectSwitchItem(this.activeIndex)
        // 打开选择城市 获取 定位当前城市
        this.getLocation('init')

        if (this.multiple) { // 多选则赋值
          this.multipleCities = [...this.defaultMultipleCities]
        }
      }
    },
    searchTxt(val) {
      this.timer && clearTimeout(this.timer); // eslint-disable-line
      this.timer = setTimeout(() => {
        this._vague(val)
      }, 500)
    }
  },
  methods: {
    _cancel() {
      this.showSearchDetails = false
      this.searchTxt = ''
    },

    // 根据activeIndex && 显示的名称,比如:国内, 来判断加载不同的城市json
    _selectSwitchItem(index) {
      this.searchTxt = '' // 重置

      this.$emit('update:activeIndex', index)

      // 改变this.blank后, 为this.localStorageHistoryKey赋值
      this.blank = this.switchList[index]

      if (this.OrderBusinessType === 18) { // 汽车票
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_BUS_CITY'
        this._getCityWithBus()
      } else if (this.blank === this.PLANE_BLANK && this.OrderBusinessType === 17) { // 出差申请单国内城市
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_TRAVEL_APPLY_CITY'
        this._getCityWithTravelApply()
      } else if (this.blank === this.INTER_TRAVEL_BLANK && this.OrderBusinessType === 17) { // 出差申请单国际城市
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_INTL_TRAVEL_APPLY_CITY'
        this._getIntlCityWithTravelApply()
      } else if (this.blank === this.PLANE_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_PLANE_CITY'
        this._getCityDataWithDomsticPlane()
      } else if (this.blank === this.INTEL_PLANE_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_INTL_PLANE_CITY'
        this._getCityDataWithIntlPlane()
      } else if (this.blank === this.HOTEL_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_HOTEL_CITY'
        this._getCityDataWithDomsticHotel()
      } else if (this.blank === this.INTEL_HOTEL_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_INTER_HOTEL_CITY'
        this._getCityDataWithIntlHotel()
      } else if (this.blank === this.TRAIN_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_TRAIN_CITY'
        this._getCityDataWithDomsticTrain()
      } else if (this.blank === this.CAR_BLANK) {
        this.localStorageHistoryKey = 'HISTORY_DOMESTIC_CAR_CITY'
        this._kpiCarCityAvailableList()
      }
      // ==============================================================
      this._clearCityHistory() // 清空城市缓存
      this.historyAddress = window.localStorage[this.localStorageHistoryKey] ? JSON.parse(window.localStorage[this.localStorageHistoryKey]) : []
    },

    _scrollInit(){
      let el = document.getElementById('letterA');
      let elTop = el ? el.getBoundingClientRect().top : 0
      if (elTop < 101) {
        this.showBackToTop = true
      } else {
        this.showBackToTop = false
      }
    },

    _backTop() {
      let refTableView = this.$refs.tableView
      refTableView && refTableView.$el.scrollTo({
        behavior: 'smooth',
        top: 0
      })
    },

    _clearHistory() {
      window.localStorage[this.localStorageHistoryKey] = '[]'
      this.historyAddress = []
    },

    // 清空城市缓存
    _clearCityHistory() {
      // 海外酒店城市缓存 城市缓存 不存在 或城市缓存版本号不一致 则 清空缓存的海外酒店城市
      if (this.blank === this.INTEL_HOTEL_BLANK) {
        if (window.localStorage.INTER_HOTEL_CITY) {
          let cityData = JSON.parse(window.localStorage.INTER_HOTEL_CITY)
          if (!cityData || !this.CityVersion.IntlHotelCityVersionV2 || cityData.version !== this.CityVersion.IntlHotelCityVersionV2) {
            window.localStorage[this.localStorageHistoryKey] = '[]'
          }
        } else {
          window.localStorage[this.localStorageHistoryKey] = '[]'
        }
      }
    },

    /** 获取缓存key */
    _getLocalStorageHistoryKey(item) {
      /** 针对国内 国际机票 国内国际同时搜索 根据城市类型更新对应的缓存key */
      if (this.blank === this.PLANE_BLANK || this.blank === this.INTEL_PLANE_BLANK || this.blank === this.INTER_TRAVEL_BLANK) {
        if (this.OrderBusinessType === 17) { // 出差申请单
          this.localStorageHistoryKey = (Number(item.CityType) === 2) ? 'HISTORY_DOMESTIC_INTL_TRAVEL_APPLY_CITY' : 'HISTORY_DOMESTIC_TRAVEL_APPLY_CITY'
        } else {
          this.localStorageHistoryKey = (item.CountryType === '国际') ? 'HISTORY_INTL_PLANE_CITY' : 'HISTORY_DOMESTIC_PLANE_CITY'
        }
      }
    },

    /** 获取汽车票城市 */
    _getCityWithBus() {
      console.log('获取国内机票地址数据')
      if (window.localStorage.HISTORY_DOMESTIC_BUS_CITY) {
        this.cityData = JSON.parse(window.localStorage.HISTORY_DOMESTIC_BUS_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (
        !this.cityData ||
        !this.CityVersion.BusVersion ||
        this.cityData.version !== this.CityVersion.BusVersion
      ) {
        kpiBusCommonQueryCities().then((res) => {
          console.log('更新国内机票JSON: ', res)
          let original = cloneObject(res.ResultData || [])
          original.map(m => {
            m.Cities.map(k => {
              k.CityName_CN = k.CityName
              k.CityName_EN = k.PinYin
            })
          })
          this._saveLocalStorageWithStaticJson_3('DOMESTIC_BUS_CITY', original, this.CityVersion.BusVersion)
        })
      }
    },

    /** 获取出差申请单国内城市 */
    _getCityWithTravelApply() {
      console.log('获取国内机票地址数据')
      if (window.localStorage.DOMESTIC_TRAVEL_APPLY_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_TRAVEL_APPLY_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (
        !this.cityData ||
        !this.CityVersion.TripApplicationFromVersion ||
        this.cityData.version !== this.CityVersion.TripApplicationFromVersion
      ) {
        kpiApplicationCityList().then((res) => {
          console.log('更新国内机票JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData.Cities))
          this._saveLocalStorageWithStaticJson_3('DOMESTIC_TRAVEL_APPLY_CITY', original, this.CityVersion.TripApplicationFromVersion)
        })
      }
    },

    /** 获取出差申请单国际城市 */
    _getIntlCityWithTravelApply() {
      console.log('获取国内机票地址数据')
      if (window.localStorage.DOMESTIC_INTL_TRAVEL_APPLY_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_INTL_TRAVEL_APPLY_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (
        !this.cityData ||
        !this.CityVersion.TripApplicationFromInterVersion ||
        this.cityData.version !== this.CityVersion.TripApplicationFromInterVersion
      ) {
        kpiApplicationIntlCityList().then((res) => {
          console.log('更新国内机票JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData.Cities))
          this._saveLocalStorageWithStaticJson_4('DOMESTIC_INTL_TRAVEL_APPLY_CITY', original, this.CityVersion.TripApplicationFromInterVersion)
        })
      }
    },

    /** 获取国内机票地址数据 */
    _getCityDataWithDomsticPlane() {
      console.log('获取国内机票地址数据')
      if (window.localStorage.DOMESTIC_PLANE_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_PLANE_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (!this.cityData || !this.CityVersion.FlightCityVersion || this.cityData.version !== this.CityVersion.FlightCityVersion) {
        kpiFlightGetAllCities().then((res) => {
          console.log('更新国内机票JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          this._saveLocalStorageWithStaticJson_1('DOMESTIC_PLANE_CITY', original, this.CityVersion.FlightCityVersion)
        })
      }
    },
    /** 获取国际机票地址数据 */
    _getCityDataWithIntlPlane() {
      if (window.localStorage.INTL_PLANE_CITY) {
        this.cityData = JSON.parse(window.localStorage.INTL_PLANE_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (!this.cityData || !this.CityVersion.IntlFlightCityVersion || this.cityData.version !== this.CityVersion.IntlFlightCityVersion) {
        kpiIntlflightGetIntlFlightCityList().then((res) => {
          console.log('更新国际机票JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          this._saveLocalStorageWithStaticJson_2('INTL_PLANE_CITY', original, this.CityVersion.IntlFlightCityVersion)
        })
      }
    },
    /** 获取国内酒店地址数据 */
    _getCityDataWithDomsticHotel() {
      if (window.localStorage.DOMESTIC_HOTEL_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_HOTEL_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (!this.cityData || !this.CityVersion.HotelCityVersion || this.cityData.version !== this.CityVersion.HotelCityVersion) {
        kpiHotelGetHotelCityList().then((res) => {
          console.log('更新国内酒店JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          this._saveLocalStorageWithStaticJson_1('DOMESTIC_HOTEL_CITY', original, this.CityVersion.HotelCityVersion)
        })
      }
    },
    /** 获取国际酒店地址数据 */
    _getCityDataWithIntlHotel() {
      if (window.localStorage.INTER_HOTEL_CITY) {
        this.cityData = JSON.parse(window.localStorage.INTER_HOTEL_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (!this.cityData || !this.CityVersion.IntlHotelCityVersionV2 || this.cityData.version !== this.CityVersion.IntlHotelCityVersionV2) {
        kpiIntlHotelGetIntlHotelCityList().then((res) => {
          console.log('更新国内酒店JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          this._saveLocalStorageWithStaticJson_1('INTER_HOTEL_CITY', original, this.CityVersion.IntlHotelCityVersionV2)
        })
      }
    },
    /** 获取国内火车票地址数据 */
    _getCityDataWithDomsticTrain() {
      if (window.localStorage.DOMESTIC_TRAIN_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_TRAIN_CITY)
      } else {
        this.cityData = {list: []}
      }
      if (!this.cityData || !this.CityVersion.TrainCityVersion || this.cityData.version !== this.CityVersion.TrainCityVersion) {
        kpiTrainGetTrainCityList().then((res) => {
          console.log('更新国内酒店JSON: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          this._saveLocalStorageWithStaticJson_1('DOMESTIC_TRAIN_CITY', original, this.CityVersion.TrainCityVersion)
        })
      }
    },
    /** 获取国内用车数据 */
    _kpiCarCityAvailableList() {
      console.log('更新用车JSON数据')
      if (window.localStorage.DOMESTIC_CAR_CITY) {
        this.cityData = JSON.parse(window.localStorage.DOMESTIC_CAR_CITY)
      } else {
        this.cityData = {list: []}
      }
      // if (!this.cityData || this.cityData.version !== this.CityVersion.FlightCityVersion ) {
      if (!this.cityData || !this.cityData.list || this.cityData.list.length <= 0) {
        kpiCarCityAvailableList().then((res) => {
          console.log('更新用车JSON数据: ', res)
          let original = JSON.parse(JSON.stringify(res.ResultData))
          original = original.map(d => {
            if (d.CityList && d.CityList.length > 0) {
              d.CityList = d.CityList.map(m => {
                m.CityName_CN = m.CityName
                m.CityName_EN = m.CityEName
                m.CityName_JP = m.CityName_JP || m.CityName
                return m
              })
            }
            return d
          })
          this._saveLocalStorageWithStaticJson_1('DOMESTIC_CAR_CITY', original, this.CityVersion.FlightCityVersion)
        })
      }
    },
    _saveLocalStorageWithStaticJson_1(Name, original, version) {
      // 挑选出热门
      let hot = JSON.parse(JSON.stringify(original))[0]
      let list = JSON.parse(JSON.stringify(original)).slice(1)
      // 重新组合
      this.cityData = {hot: hot, list: list, version: version}
      window.localStorage.removeItem(`HISTORY_${Name}`)
      window.localStorage.setItem(Name, JSON.stringify(this.cityData))
    },
    _saveLocalStorageWithStaticJson_2(Name, original, version) {
      this.cityData = {
        list: original.map(v => {
          let list = []
          if (v.Label === '热门') {
            v.Label = '历史/热门'
            v.Label_EN = 'History/Hot'
            list.push({
              Label: '热门',
              Label_EN: this.$t('Hot'),
              CityList: v.CityList
            })
          } else {
            let countrys = v.CityList.map(v => v.CountryName_CN)
            let maplist = new Map()
            countrys = countrys.filter(a => !maplist.has(a) && maplist.set(a, 1))
            countrys.forEach(element => {
              let item = v.CityList.filter(v => v.CountryName_CN === element)
              list.push({
                Label: element,
                Label_EN: item[0] ? item[0].CountryName_EN : '',
                Label_JP: item[0] ? (item[0].CountryName_JP || element) : '',
                CityList: item
              })
            })
          }
          v.Blanks = list
          return v
        }),
        version: version
      }
      window.localStorage.removeItem(`HISTORY_${Name}`)
      window.localStorage.setItem(Name, JSON.stringify(this.cityData))
    },

    _saveLocalStorageWithStaticJson_3(Name, original, version) {
      original = original.map(m => {
        return {
          CityList: m.Cities,
          Label: m.Label,
          LabelType: m.LabelType,
          Label_EN: m.Label_EN,
          Label_JP: m.Label_JP || m.Label
        }
      })
      // 挑选出热门
      let hot = JSON.parse(JSON.stringify(original))[0]
      let list = JSON.parse(JSON.stringify(original)).slice(1)
      // 重新组合
      this.cityData = {hot: hot, list: list, version: version}
      window.localStorage.removeItem(`HISTORY_${Name}`)
      window.localStorage.setItem(Name, JSON.stringify(this.cityData))
    },

    _saveLocalStorageWithStaticJson_4(Name, original, version) {
      this.cityData = {
        list: original.map(v => {
          let list = []
          if (v.Label === '热门') {
            v.Label = '历史/热门'
            v.Label_EN = 'History/Hot'
            list.push({
              Label: '热门',
              Label_EN: this.$t('Hot'),
              CityList: v.Cities
            })
          } else {
            let countrys = v.Cities.map(v => v.CountryName_CN)
            let maplist = new Map()
            countrys = countrys.filter(a => !maplist.has(a) && maplist.set(a, 1))
            countrys.forEach(element => {
              let item = v.Cities.filter(v => v.CountryName_CN === element)
              list.push({
                Label: element,
                Label_EN: item[0] ? item[0].CountryName_EN : '',
                Label_JP: item[0] ? (item[0].CountryName_JP || element) : '',
                CityList: item
              })
            })
          }
          v.Blanks = list
          return v
        }),
        version: version
      }
      window.localStorage.removeItem(`HISTORY_${Name}`)
      window.localStorage.setItem(Name, JSON.stringify(this.cityData))
    },

    /** 模糊搜索 */
    _vague(val) {
      if (this.noValue(val)) {
        this.vaguelist = []
        return
      }
      if (this.OrderBusinessType === 18) { // 汽车票
        let params = {
          KeyWord: this.searchTxt
        }
        kpiBusCommonGetCitiesByKeyWord(params).then((res) => {
          console.log('模糊汽车票车站: ', res)
          this.vaguelist = res.ResultData || []
          this.vaguelist = this.vaguelist.map(m => {
            m.CityName_CN = m.CityInfo.CityName
            m.CityName_EN = m.CityInfo.PinYin
            m.CityCode = m.CityInfo.CityCode
            m.StationInfoList.map(k => {
              k.CityName_CN = k.BelongCityName
              k.CityName_EN = k.BelongCityName
              k.CityCode = k.BelongCityCode
            })
            return m
          })
        })
      } else if (this.OrderBusinessType === 17) { // 出差申请单城市搜索
        let params = {
          ResultCount: 15,
          Keyword: this.searchTxt
        }
        if (this.blank === this.$t('China')) {
          params.SerchAirPortCityType = 1
        } else if (this.blank === this.INTER_TRAVEL_BLANK) {
          params.SerchAirPortCityType = 2
        }
        kpiApplicationSearchCity(params).then((res) => {
          console.log('模糊搜索机场和城市: ', res)
          this.vaguelist = res.ResultData || []
        })
      } else if (this.blank === this.PLANE_BLANK || this.blank === this.INTEL_PLANE_BLANK) {
        let params = {
          CountryType: 0,
          KeyWord: this.searchTxt
        }
        if (this.switchList && this.switchList.length === 1) {
          if (this.switchList[0] === this.$t('China')) {
            params.CountryType = 1
          } else if (this.switchList[0] === this.$t('InternationalRegion')) {
            params.CountryType = 2
          }
        }
        kpiFlightSearchAirportCity(params).then((res) => {
          console.log('模糊搜索机场和城市: ', res)
          this.vaguelist = res.ResultData
        })
      } else if (this.blank === this.HOTEL_BLANK) {
        let params = {
          KeyWord: this.searchTxt,
          SearchType: 0, // 查询入口 城市 0 关键词 1
          MapSource: this.AMapKey && this.AMapKey.MapSource || '',
        }
        kpiHotelGetHotelSearchEngine(params).then((res) => {
          console.log('模糊搜索国内酒店: ', res)
          let list = res.ResultData && res.ResultData.HotelSearchResultDTOs ? res.ResultData.HotelSearchResultDTOs : []
          list = list.filter(v => v.CityId)
          this.vaguelist = list.map(m => {
            return {
              ...m,
              CityCode: m.CityId,
              CityName_CN: m.CityName,
              CityName_EN: m.CityName_EN,
              CityName_JP: m.CityName_JP,
              CityID: m.CityId
            }
          })
        })
      } else if (this.blank === this.INTEL_HOTEL_BLANK) {
        let params = {
          Keyword: this.searchTxt,
          SearchType: 0 // 查询入口 城市 0 关键词 1
        }
        kpiIntlHotelGetIntlHotelCityByKeyword(params).then((res) => {
          console.log('模糊搜索国际酒店: ', res)
          let list = res.ResultData && res.ResultData.CurrentCityResults ? res.ResultData.CurrentCityResults : []
          list = list.filter(v => v.CityId)
          this.vaguelist = list.map(m => {
            return {
              ...m,
              CityCode: m.CityId,
              CityName_CN: m.CityName,
              CityName_EN: m.CityName_EN,
              CityName_JP: m.CityName_JP,
              CountryName_CN: m.CountryName,
              CityID: m.CityId
            }
          })
        })
      } else if (this.blank === this.TRAIN_BLANK) {
        let params = {
          Keyword: this.searchTxt
        }
        kpiTrainSearchTrainStations(params).then((res) => {
          console.log('模糊搜索火车票: ', res)
          this.vaguelist = (res.ResultData || []).map(v => {
            return {
              CityCode: v.Code,
              CityName_CN: v.Name,
              CityName_EN: v.EnglishName,
              CityName_JP: v.Name,
              GeoType: v.TrainGeoType,
              Stations: v.Stations && v.Stations.length > 0 ? v.Stations.map(m => {
                return {
                  CityCode: m.Code,
                  CityName_CN: m.Name,
                  CityName_EN: m.EnglishName,
                  CityName_JP: m.Name,
                  GeoType: m.TrainGeoType
                }
              }) : []
            }
          })
        })
      } else if (this.blank === this.CAR_BLANK) {
        let params = {
          CityName: this.searchTxt
        }
        kpiCarCityQuery(params).then((res) => {
          console.log('模糊搜索用车城市: ', res)
          this.vaguelist = res.ResultData
          this.vaguelist = this.vaguelist.map(m => {
            m.CityName_CN = m.CityName
            m.CityName_EN = m.CityEName
            m.CityName_JP = m.CityName_JP || m.CityName
            return m
          })
        })
      }
    },

    /** 字母快速选择 */
    _selectLetter(item, index) {
      let refLabel = this.$refs[`letter${item.Label}${index}`]
      refLabel && (refLabel[0].show = true)
      let refTableView = this.$refs.tableView
      setTimeout(() => {
        if (refLabel && refLabel[0] && refLabel[0].$el && refTableView && refTableView.$el) {
          refTableView.$el.scrollTo({
            behavior: 'smooth',
            top: refLabel[0].$el.offsetTop
          })
        }
      }, 100)
    },

    /** 国内酒店城市搜索选中事件 */
    _selectHotelSearch(item) {
      this._select(item, 'hotelSearchSelected')
    },

    _select(item, type) {
      console.log('选择: ', item)
      this._setSelectedCityHistory(item)
      // 当是国内酒店 搜索 结果触发的选中时
      if (this.multiple) { // 多选
        if (this.multipleCities.findIndex(m => m.CityCode === item.CityCode) < 0) {
          this.multipleCities.push({...item})
          this.showSearchDetails = false
          this.searchTxt = ''
        } else {
          this.$toast(this.$t('TheCityHasBeenSelected'))
        }
      } else {
        this.$emit('select', item, type)
        this.showSearchDetails = false
        this.currentValue = false
      }
    },

    // 多选删除
    _multipleDelete(i) {
      let list = [...this.multipleCities]
      list.splice(i, 1)
      this.multipleCities = [...list]
    },

    // 多选确认
    _confirm() {
      this.$emit('confirm', this.multipleCities)
      this.showSearchDetails = false
      this.currentValue = false
    },

    /** 设置选中城市缓存 */
    _setSelectedCityHistory(item) {
      // 如果选中的城市和当前城市相同不缓存
      if (
        !this.locationCity ||
        (this.locationCity && this.locationCity.CityCode && item.CityCode !== this.locationCity.CityCode)
      ) {
        this._getLocalStorageHistoryKey(item)
        // 储存历史选取的城市
        let localStorage = window.localStorage

        // 初始化赋值
        let historyAddress = localStorage[this.localStorageHistoryKey] ? JSON.parse(localStorage[this.localStorageHistoryKey]) : []

        //  数组头部插入
        historyAddress.unshift(item)

        // 去重
        let maplist = new Map()
        historyAddress = historyAddress.filter(a => !maplist.has(`${this.getCityName(a)}_${this.getAirPortName(a)}`) && maplist.set(`${this.getCityName(a)}_${this.getAirPortName(a)}`, 1))

        // 截取
        historyAddress = historyAddress.slice(0, 3)

        localStorage[this.localStorageHistoryKey] = JSON.stringify(historyAddress)
        this.historyAddress = localStorage[this.localStorageHistoryKey] ? JSON.parse(localStorage[this.localStorageHistoryKey]) : []
        // =====================================================================================
      }
    },

    /** 获取经纬度从而获取详细地址或者城市  type === getLngAndLat 仅获取经纬度 此时不提示失败信息 如需提示加参数调整 */
    async getLocation(type) {
      this._selectSwitchItem(this.activeIndex)
      // 匹配城市数据 依赖 cityData 等待 cityData 被赋值后继续
      if (!this.cityData || !this.cityData.list || !this.cityData.list.length) {
        await new Promise(resolve => {
          // 对于异步操作，监听cityData变化
          let index = 0
          const checkData = () => {
            index++
            if (index > 20) {
              resolve()
              return
            }
            // console.log('index', index)
            if (this.cityData && this.cityData.list && this.cityData.list.length) {
              resolve();
            } else {
              // 短暂延迟后再次检查
              setTimeout(checkData, 200);
            }
          };
          // 开始检查
          checkData();
        })
      }
      try {
        let position = await LocationService.getCurrentPosition({}, this.cityData)
        if (!position) {
          return
        }
        if (type === 'getLngAndLat') {
          this.$emit('delegateWithLngWithLatWithAddress', position.lng, position.lat)
        } else if (type !== 'init') {
          this._select(position)
          this.$emit('delegateWithLngWithLatWithAddress', position.lng, position.lat, position.DetailAddress, position.MapSource)
        } else { // 初始化默认匹配定位获取的当前城市的位置
          this._handleLocationCity(position)
        }
      } catch (error) {
        console.error('定位失败:', error.message);
        type !== 'getLngAndLat' && type !== 'init' && this.$toast(this.$t('UnableToLocateCurrentCity'))
      }
    },

    /** 根据定位的当前城市匹配当前历史过滤数据 */
    _handleLocationCity(elementChild) {
      this.locationCity = elementChild

      let localStorage = window.localStorage

      // 初始化赋值
      let historyAddress = localStorage[this.localStorageHistoryKey] ? JSON.parse(localStorage[this.localStorageHistoryKey]) : []

      let index = historyAddress.findIndex(m => m.CityCode === elementChild.CityCode)
      if (index >= 0) {
        historyAddress.splice(index, 1);
      }
      localStorage[this.localStorageHistoryKey] = JSON.stringify(historyAddress)
      this.historyAddress = localStorage[this.localStorageHistoryKey] ? JSON.parse(localStorage[this.localStorageHistoryKey]) : []
      console.log('根据定位的当前城市匹配当前历史过滤数据', elementChild)
    },

    _getLabel(item) {
      let language = this.language
      if (item.Label === '热门') {
        return this.$t('hot')
      }
      if (language === 'TC' || language === 'CN' || language === 'HK') {
        return item.Label
      }
      if (language === 'JAP') {
        return item.Label_JP || item.Label
      }
      return item.Label_EN || item.Label
    },

    // 获取 Label_EN 兼容老数据处理
    _getLabelCnOrEn(item) {
      let language = this.language
      if (language === 'EN') {
        if (item.Label_EN) {
          return item.Label_EN
        } else if (item.Label === '热门') {
          return this.$t('Hot')
        } else if (item.CityList && item.CityList[0]) {
          return item.CityList[0].CountryName_EN
        }
        return item.Label
      } else if (language === 'JAP') {
        if (item.Label_JP) {
          return item.Label_JP
        } else if (item.Label === '热门') {
          return this.$t('Hot')
        } else if (item.CityList && item.CityList[0]) {
          return item.CityList[0].CountryName_JP || item.CityList[0].CountryName_CN
        }
        return item.Label_EN || item.Label
      }
      return item.Label
    }
  },
  components: {
    HsNull,
    CHeader: () => import('components/c-header/c-header'),
    HsClose: () => import('base/hs-close/hs-close'),
    HsAddressPickerItem: () => import('./hs-address-picker-item'),
    HsAddressPickerSearchItem,
    HsAddressPickerSearchBar,
    CHotelFilterSearchList,
    HsCell1,
    HsScroll,
    HsSection,
    HsTab
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
@import '~common/stylus/popup-mask.styl'
.hs-address-picker
  width 100%
  height 95%
  position fixed
  top 5%
  left 0
  background-color $color_white
  z-index 9
  border-top-left-radius 10px
  border-top-right-radius 10px
  overflow hidden
  .close
    @extend .flex-center
    height 100%
    padding-left 20px
    img
      width 15px
      height 15px
  // 搜索框
  .search-bar
    @extend .flex-row
    @extend .flex-center
    width 100%
    padding 10px 15px
    background-color $color_white
    &.search-bar-new
      padding 5px 15px
      >.bar
        border-radius 4px
    >.bar
      @extend .flex-row
      @extend .flex-between
      flex 1
      border-radius 16px
      padding 5px 10px
      background-color $color_gray_background_0
      font-size 0.9rem
      >input
        width calc(100% - 20px)
        height 25px
        font-size 0.8rem
        background-color $color_gray_background_0
      >.logo
        width 20px
        height 20px
        background-size 100% 100%
    >.close
      font-size 0.8rem
      margin-left 10px
      flex-shrink 0
  >.search-details
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background-color $color_white
    z-index 10
    >.vaguelist
      width 100%
      height calc(100% - 55px)
      overflow hidden

      .null
        @extend .flex-row
        @extend .flex-center
        width 100%
        font-size 0.9rem
        color $color_gray_text

      .search-list
        width 100%
        background-color $color_white
        .item-city
          @extend .flex-row
          @extend .flex-start
          width 100%
          min-height 50px
          border-bottom 1px solid $color_gray_layer
          padding 10px 0
          &:last-child
            border-bottom-width 0px
          >p
            font-size 1rem
            &:nth-child(1)
              color $color_theme
              font-weight bold
              margin-right 5px
            &:nth-child(2)
              color $color_black_text_0
              font-weight bold
              margin-right 5px
            &:nth-child(3)
              color $color_gray_text
        .item-city[type="EN"],.item-city[type="JAP"]
          >p
            line-height 1.4em
            font-size 0.9rem !important
            &:nth-child(1)
              border 0
              padding 0
              font-weight bold
              >span:nth-child(2)
                color $color_black_text_0
                margin-left 5px
        .item-city-new
          flex-wrap wrap
          position relative
          .item-city-name
            @extends .flex-start
            align-items flex-start
            word-break break-all
            line-height 1.4em
            .icon
              display inline-flex
              flex-shrink 0
              width 15px
              height 1.4em
              background url(@/assets/image/base/address-picker/inter_hotel.png) center center no-repeat
              background-size 100% 15px
              margin-right 10px
          .subtext
            padding-left 25px
            width 100%
            color $color_black_text_0
            font-size 13px
            margin-top 3px
        .item-airport
          @extend .flex-row
          @extend .flex-between
          width calc(100% - 35px)
          min-height 50px
          margin-left 35px
          border-bottom 1px solid $color_gray_layer
          // &:last-child
          //   border-bottom-width 0px
          >.item-airport-details
            @extend .flex-row
            @extend .flex-start
            width calc(100% - 25px)
            padding 10px 0
            >.logo
              margin-right 5px
            >p
              font-size 1rem
            >.details
              >p
                line-height 1.4em
                &:nth-child(1)
                  @extend .no-wrap
                  color $color_theme
                  font-weight bold
                  margin-right 5px
                  >span:nth-child(2)
                    color $color_black_text_0
                    margin-left 5px
                &:nth-child(2)
                  color $color_black_text_0
                  margin-right 5px
                &:nth-child(3)
                  color $color_gray_text
          >.item-airport-details[type="CN"],>.item-airport-details[type="EN"],>.item-airport-details[type="JAP"]
            >.details
              @extend .flex-row
              @extend .flex-start
          >.item-airport-details[type="EN"],>.item-airport-details[type="JAP"]
            >.details
              font-size .9rem
          /*>.item-airport-details[type="EN"],>.item-airport-details[type="JAP"]
            >.details
              @extend .flex-column
              @extend .flex-top
              font-size 0.7rem
              >p
                &:nth-child(1)
                  border 0
                  padding 0
                  font-weight bold*/
          >.logo
            width 20px
            height 20px
            background-size 100% 100%

  .back-to-top{
    position: absolute;
    bottom: 46px;
    right: 16px;
    z-index: 1;
    background-color: $color_black_0;
    width: 48px;
    height: 48px;
    border-radius: 50vmin;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
    background-size: 24px 24px;
    background-position: center center;
    background-repeat: no-repeat;
  }
  >.tableView
    width 100%
    overflow-y: auto;
    background-color $color_gray_background_0;
    touch-action: auto;
    *{
      touch-action: auto;
    }
    .fixedTouch{
      >>> .details{
        touch-action: auto;
      }
    }
    .blank
      width 100%
      padding 0 15px
      padding-top 15px
      &[type="EN"],&[type="JAP"]
        >.details
          >.item
            min-height 50px
            justify-content flex-start
            align-items center
            width 100%
            margin-right 0
            text-align left
            border none
            border-bottom 1px solid #e8e8e8
            margin-bottom 0
            font-size 1rem
            >p
              word-break break-all
              text-align left
      >.header
        width 100%
        font-weight bold
        margin-bottom 15px
      >.details
        @extend .flex-row
        @extend .flex-start
        @extend .flex-top
        flex-wrap wrap
        align-items stretch
        width 100%
        >.item
          @extend .flex-row
          @extend .flex-center
          width calc(25% - 7.5px)
          // height 30px
          min-height 30px
          padding 2px
          border 1px solid $color_gray_layer
          border-radius 2px
          font-size 0.8rem
          margin-right 10px
          margin-bottom 10px
          .location-logo
            display inline-flex
            width 14px
            height 14px
            background url(@/assets/image/hotel/location.png) no-repeat
            background-size 100% 100%
            vertical-align middle
          &:nth-child(4n + 4)
            margin-right 0px
          >.logo
            width 15px
            height 15px
            background-size 100% 100%
            margin-right 5px
          >p
            /*ellipsis(1)
            height 1em
            overflow hidden*/
            text-align center
            >.gray
              color $color_gray_text
        >.letter
          @extend .flex-center
          width calc(12.5% - 8.75px)
          height 30px
          border 1px solid $color_gray_layer
          border-radius 2px
          font-size 0.8rem
          margin-right 10px
          margin-bottom 10px
          &:nth-child(8n + 8)
            margin-right 0px

  >.intl
    @extend .flex-row
    @extend .flex-start
    width 100%
    >.left
      width 100px
      height 100%
      overflow hidden
      background-color $color_gray_background_0
      .item
        @extend .flex-row
        @extend .flex-center
        width 100%
        height 40px
        background-color $color_gray_background_0
        padding 0 15px
        font-size 0.8rem
        color $color_black_text_1
      .active
        background-color $color_white !important
    >.right
      width calc(100% - 100px)
      height 100%
      overflow hidden
      background-color $color_white
      .blank
        width 100%
        padding 0 15px
        padding-top 15px
        &[type="EN"],&[type="JAP"]
          >.details
            >.item
              min-height 50px
              justify-content flex-start
              align-items center
              width 100%
              margin-right 0
              text-align left
              border none
              border-bottom 1px solid #e8e8e8
              margin-bottom 0
              font-size 1rem
        >.header
          width 100%
          font-weight bold
          margin-bottom 15px
        >.details
          @extend .flex-row
          @extend .flex-start
          @extend .flex-top
          flex-wrap wrap
          width 100%
          >.item
            @extend .flex-row
            @extend .flex-center
            width calc(33.33% - 6.67px)
            height 30px
            border 1px solid $color_gray_layer
            border-radius 2px
            font-size 0.8rem
            margin-right 10px
            margin-bottom 10px
            &:nth-child(3n + 3)
              margin-right 0px
            >.logo
              width 15px
              height 15px
              background-size 100% 100%
              margin-right 5px
            >p
              ellipsis(1)
              height 1.2em
              line-height 1.2em
              overflow hidden
              >.gray
                color $color_gray_text
          >.itemWidthImage
            @extend .flex-center
            width calc(50% - 5px)
            height 94px
            border-radius 3px
            margin-right 10px
            margin-bottom 10px
            background-size auto 100%
            background-position center center
            background-repeat no-repeat
            position relative
            overflow hidden
            &:nth-child(2n + 2)
              margin-right 0px
            >p
              ellipsis(1)
              height 1em
              overflow hidden
              color $color_white
              font-size 0.9rem
              position relative
              z-index 1
            >.mask
              position absolute
              top 0
              left 0
              width 100%
              height 100%
              background-color $color-black_5

.hs-address-picker-new{
  >.search-bar{
    &.search-bar-new {
      padding 10px 12px;

      > .bar {
        height: 36px;
        border-radius: 8px;
        padding: 0 8px;
        >input{
          @extend .hs-font-body;
        }
      }
    }
  }
}
.address-picker-enter-active
.address-picker-leave-active
  transition: all 300ms
  -webkit-transition: all 300ms
.address-picker-enter
.address-picker-leave-to
  transform translateY(100%)
</style>
